/**
 * @file   src\Pages\AddSubscription.tsx
 * @brief  AddSubscription page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { useState, useRef, useEffect, Container, Badge, Button, Breadcrumb, Row, Col, useOutletContext, useNavigate, useLocation, useParams, React } from '../utils/thirdpartyComponents';
// import "../styles
import CWSelect from '../components/CWSelect';
import CWInput from '../components/CWInput';
import CWInputGroup from '../components/CWInputGroup';
import { pageURLs } from '../utils/pageUrls';
import * as Yup from 'yup'
import { MessageToaster } from '../utils/toastUtil';
import { addSubscriptionSchema } from '../validations/addSubscriptionSchema';
import { AMOUNT_MAX_LENGTH, WASH_DETAIL_MAX_LENGTH, WASH_NAME_MAX_LENGTH, WASH_NUMBER_MAX_LENGTH } from '../utils/constants';
import { AppContextType } from '../interfaces/generalInterface';
import CWMultiSelect from '../components/CWMultiSelect';
import GenerateLink from '../components/GenerateLink';
import CarWashStatus from '../components/CarWashStatus';
import axios from '../config/axiosConfig';
import { CompanyApi, LocationApi, SubscriptionApi } from '../utils/apiUrls';
import { LocationItem, Option, SubscriptionDataItem, SubscriptionItem } from '../interfaces/subscriptionInterface';
import CWTextarea from '../components/CWTextarea';
import { serviceType, userType } from '../utils/enums';
import CWCheckbox from '../components/CWCheckbox';
import SmallLoader from '../components/SmallLoader';
import { CommonMessages } from '../messages/validationMessages';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Essentials, Paragraph, Bold, Italic, Heading } from 'ckeditor5';
import ClassicEditor from '../utils/classicEditor';
    interface DiscountData {
  [key: string]: number | string; // allow dynamic keys like discount1...discount10
}
interface ErrorData {
  [key: string]: string;
}
const EditSubscription = (props: any) => {
    const carwash_owner = (props.userType === userType['CARWASH-OWNER']) ? true : false
    // State to handle locations given in dropdown
    const [locations, setLocations] = useState<Option[]>([]);
    const [categoryOptions, setCategoryOptions] = useState<Option[]>([]);
    const [category, setCategory] = useState<number | ''>('');
    
    // State to handle subscription types given in dropdown
    const subscriptionTypes = [
        { label: "Single wash", value: "day" },
        { label: "Monthly", value: "month" },
    ];

    // To get path from which redirection was done
    const location = useLocation();
    const currentBayType = location?.state?.bayType||0
    // Use a ref to store input elements
    const formRef = useRef<HTMLFormElement>(null);

    // Initialize states for subscriptionData
    const [subscriptionData, setSubscriptionData] = useState<Partial<SubscriptionDataItem>>({})

       const [isFamilyPlan,setIsFamilyPlan]=useState(false);
        const [familyPlanErrors,setFamilyPlanErrors] =  useState<ErrorData>({});
        const [editorKey, setEditorKey] = useState(0);
        const [discountData, setDiscountData] = useState<DiscountData | null>({
            discount1: "",
            discount2: "",
            discount3: "",
            discount4: "",
            discount5: "",
            discount6: "",
            discount7: "",
            discount8: "",
            discount9: "",
            discount10: ""
        });

    // Initialise states for errors
    const [errors, setErrors] = useState({
        location: '',
        subscription: '',
        washname: '',
        washdetails: '',
        washnumber: '',
        maxwashperday: '',
        amount: '',
        trialAmount: '',
        trialPeriod: '',
        hasVacuumWash: '',
        numberOfVacuumWashes: '',
        maxVacuumTime: '',
        numberOfSelfServeWashes:'',
        maxSelfServiceTime:"",
        category: '',
    });

    const param = useParams()
    // State to handle selected location
    const [selectedLocation, setSelectedLocation] = useState<Option[]>([]);
    const [showCategory, setShowCategory] = useState(false);
    const categoryVisibilityRequest = useRef(0);

    // Access the context
    const { updateData } = useOutletContext<AppContextType>();
    const [companyDetails, setCompanyDetails] = useState<any>({});

    const navigate = useNavigate()

    const toaster = new MessageToaster();

    const [loading, setLoading] = useState(false);
    const [fullEditAllowed, setFullEditAllowed] = useState(false);
    const [isTrailAmountNonEditable, setTrailAmountNonEditable] = useState(false);

    const query = new URLSearchParams(location.search);
    const subscription_type = query.get('type') || 'month'


    useEffect(() => {
        getCompany()
        getSubscriptionData()
        getCategories()
    }, [])


    // useEffect(() => {
           

    // }, [subscriptionData])


    useEffect(() => {
        // To display heading
        handleUpdate()
    }, [param.carWashId])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: subscription_type === 'day' ? 'Edit Single Wash' : 'Edit Subscription', url: (!carwash_owner) ? `/superadmin/${pageURLs.manage_subscriptions}/${param.carWashId}` : `/${pageURLs.manage_subscriptions}?type=${subscription_type}&bayType=${currentBayType}`, showBackButton: true, showMainMenu: true, activeLink: (!carwash_owner) ? "manage-car-wash" : "manage-subscriptions" });
    };

    const setFreeVacuumData = async (e: any) => {
        if (e.target.name === 'hasVacuumWash') {
            if (e.target.checked === true) {
                if(subscriptionData.subscription === 'day')
                {
                    setSubscriptionData({
                    ...subscriptionData,
                    'numberOfVacuumWashes':'1',
                    [e.target.name]: e.target.checked,
                });
                }
                else{
                    setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                });
                }
                
            } else {
                setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                    ['hasVacuumWash']: false,
                    ['numberOfVacuumWashes']: '0',
                    ['maxVacuumTime']: '0',
                });
            }
        } 
    }

 const setFreeSelfServeData = async (e: any) => {
        if (e.target.name === 'hasSelfService') {
            if (e.target.checked === true) {
               
                    setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                });
                
            } else {
                setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                    ['hasSelfService']: false,
                    ['numberOfSelfServices']: '0',
                    ['maxSelfServiceTime']: '0',
                });
            }
        } 
    }



const handleDiscountChange = (e:any) => {
    const { name, value } = e.target;
      // Prevent non-numeric input (allow empty and decimals)
    if (value !== "" && !/^\d*\.?\d*$/.test(value)) {
      setFamilyPlanErrors((prev) => ({
        ...prev,
        [name]: "Please enter a valid number",
      }));
      return;
    }
    setDiscountData((prev) => ({
      ...prev,
      [name]: value
    }));

       if (!value.trim()) {
      setFamilyPlanErrors((prev) => ({
        ...prev,
        [name]: "Family plan amount is required",
      }));
    } else if (isNaN(Number(value))) {
      setFamilyPlanErrors((prev) => ({
        ...prev,
        [name]: "Please enter a valid number",
      }));
    } else {
      setFamilyPlanErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

    // Function to fetch company information
    const getCompany = async () => {
        try {
            const param1 = `${param.carWashId}`;
            const { data } = (!carwash_owner) ?
                await axios.get(CompanyApi.GET_COMPANY + param1)
                : await axios.get(CompanyApi.CARWASH_OWNER_COMPANY_DETAILS)
            setCompanyDetails(data.data)
            // To get locations under company
            await getCompanyLocations(data.data.carWashGUID)

        } catch (error: any) {
            console.error('Error fetching company information:', error.message);
            throw new Error(error.response?.data?.message || error.message);
        }
    };

    const getCompanyLocations = async (carwashGuid: string) => {
        try {

            const { data } = (!carwash_owner) ?
                await axios.get(LocationApi.GET_COMPANY_LOCATIONS + carwashGuid)
                : await axios.get(LocationApi.CARWASH_OWNER_GET_COMPANY_LOCATIONS);
            if (data.error === 0) {
                const location_list: LocationItem[] = data?.data

                // Transform the array
                const transformedArray: Option[] = location_list.map(item => ({
                    label: item.locationName,
                    value: item.locationId,
                }));

                setLocations(transformedArray)
            }
            else {
                // show error message
                toaster.toastError(data.message);
            }
        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    const getCategories = async () => {
        try {
            const { data } = await axios.get(
                !carwash_owner
                    ? LocationApi.ADMIN_GET_CATEGORIES
                    : LocationApi.GET_CATEGORIES
            );
            if (data.error === 0) {
                const categoryList = Array.isArray(data?.data) ? data.data : [];
                const transformedArray: Option[] = categoryList
                    .map((item: any) => ({
                        label: item.washCategoryName ?? item.categoryName ?? item.CategoryName ?? item.name ?? item.Name,
                        value: item.washCategoryId ?? item.categoryId ?? item.CategoryID ?? item.id ?? item.ID,
                    }))
                    .filter((item: Option) => item.label && item.value !== undefined && item.value !== null);

                setCategoryOptions(transformedArray);
            }
            else {
                toaster.toastError(data.message);
            }
        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    const isComboWashLocation = (locationDetails: any) => {
        const comboWash = locationDetails?.comboWash
            ?? locationDetails?.ComboWash
            ?? locationDetails?.isComboWash
            ?? locationDetails?.IsComboWash;

        return comboWash === 1 || comboWash === true || comboWash === "1";
    }

    const resetCategory = () => {
        setCategory('');
        setErrors((prevErrors) => ({
            ...prevErrors,
            category: ''
        }));
    }

    const updateCategoryVisibility = async (selectedOptions: Option[]) => {
        const requestId = categoryVisibilityRequest.current + 1;
        categoryVisibilityRequest.current = requestId;
        const selectedLocations = selectedOptions || [];

        if (!selectedLocations.length) {
            setShowCategory(false);
            resetCategory();
            return;
        }

        try {
            const locationDetails = await Promise.all(
                selectedLocations.map((location) => {
                    const locationDetailsUrl = (!carwash_owner)
                        ? LocationApi.GET_SINGLE_LOCATION
                        : LocationApi.CARWASH_OWNER_LOCATION_DETAILS;

                    return axios.get(locationDetailsUrl + location.value);
                })
            );

            if (requestId !== categoryVisibilityRequest.current) {
                return;
            }

            const hasComboWashLocation = locationDetails.some(({ data }) => isComboWashLocation(data?.data));
            setShowCategory(hasComboWashLocation);

            if (!hasComboWashLocation) {
                resetCategory();
            }
        } catch (error: any) {
            if (requestId !== categoryVisibilityRequest.current) {
                return;
            }

            setShowCategory(false);
            resetCategory();
            toaster.toastError(error.response?.data?.message || error.message);
        }
    }

    const getSubscriptionData = async () => {
        try {
            const { data } = (!carwash_owner) ?
                await axios.get(SubscriptionApi.GET_SUBSCRIPTION_DETAILS + param.id)
                :
                await axios.get(SubscriptionApi.CARWASH_OWNER_GET_SUBSCRIPTION_DETAILS + param.id)
            if (data.error === 0) {

                const subscription: SubscriptionItem = data.data[0]
                const transformedLocationArray: Option[] =
                    subscription.Locations.map(item => ({
                        value: item.LocationID,
                        label: item.LocationName
                    }))
                const subscriptionEditAllowed = (subscription.PurchasedStatus && subscription.PurchasedStatus === true)  ? false : true // If user already purchased subscription we are not allowing to edit details
                setFullEditAllowed(subscriptionEditAllowed)
                const subscriptionCategoryId = subscription.WashCategoryID ?? (subscription as any).categoryId ?? (subscription as any).CategoryID ?? (subscription as any).CategoryId ?? (subscription as any).category_id;
                setCategory(subscriptionCategoryId !== undefined && subscriptionCategoryId !== null ? Number(subscriptionCategoryId) : '');
                updateCategoryVisibility(transformedLocationArray);

                const subscriptionData: SubscriptionDataItem = {
                    location: transformedLocationArray,
                    subscription: subscription.SubscriptionType === 1 ? "day" : "month",
                    washname: subscription.WashName,
                    washdetails: subscription.SubscriptionDetails,
                    washnumber: subscription?.NumberOfWashes?.toString() || '0',
                    maxwashperday: subscription?.DailyWashLimit?.toString() || '0',
                    amount: subscription?.Price?.toString() || '0',
                    isTrial: (subscription?.isTrial === 1) ? true : false,
                    trialPeriod: subscription.trialPeriod ? subscription.trialPeriod?.toString() : '0',
                    trialAmount: subscription?.trialAmount?.toString() || '0',
                    isFree: (subscription.isTrial && subscription?.trialAmount?.toString() == "0") ? true : false,
                    hasVacuumWash: (subscription?.hasVacuumWash === 1) ? true : false,
                    numberOfVacuumWashes:subscription?.numberOfVacuumWashes?.toString() || '0',
                    maxVacuumTime: subscription?.maxVacuumTime?.toString() || '0',
                    userFamilyDiscount:subscription?.userFamilyDiscount || null,
                    isUnlimitedWash:subscription.isUnlimitedWash ,
                    isPriceHoldEnabled: subscription?.isPriceHold === 1 || subscription?.isPriceHold === true,
                    isPriceHoldEmail: subscription?.isPriceHoldEmail === 1 || subscription?.isPriceHoldEmail === true,
                    hasSelfService:(subscription?.hasSelfService === 1) ? true : false,
                    numberOfSelfServices:subscription?.numberOfSelfServices?.toString() || '0',
                    maxSelfServiceTime: subscription?.maxSelfServiceTime?.toString() || '0',
                }
                setSubscriptionData(subscriptionData)
                 setEditorKey(prevKey => prevKey + 1);
                 if (subscriptionData?.userFamilyDiscount) {
                setDiscountData(subscriptionData.userFamilyDiscount);
                setIsFamilyPlan(true);
                }
                if(subscriptionData.isTrial && subscriptionData?.trialAmount !== undefined && parseFloat(subscriptionData?.trialAmount) > 0) {
                    setTrailAmountNonEditable(true)
                }
            }
            else {
                // show error message
                toaster.toastError(data.message);
            }
        } catch (error: any) {
            console.error('Error fetching company information:', error.message);
            // throw new Error(error.response?.data?.message || error.message);
        }
    }



    // Triggers whenever options is selected
    const handleSelectChange = (selectedOption: any, name: string) => {

        const value = selectedOption ? selectedOption.value : '';

        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        setSubscriptionData({
            ...subscriptionData,
            [name]: value,
        });

    };

    const handleMultiSelectChange = (selectedOption: Option[], name: string) => {
        setSelectedLocation(selectedOption)
        updateCategoryVisibility(selectedOption);
        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        setSubscriptionData({
            ...subscriptionData,
            [name]: selectedOption,
        });


    }

    const handleCategoryChange = (selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : '';

        setErrors({
            ...errors,
            category: ""
        });
        setCategory(value);
    }

    // Triggers whenever input is entered
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {

        const { name, value } = event.target

        // if (name === 'amount') {
        //     if (subscriptionData.subscription != "day" && fullEditAllowed === false) return;
        // }

        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        if (name === 'amount') {
            // Regex to match the input value with up to 2 decimal places
            const regex = /^\d{0,8}(\.\d{0,2})?$/;

            if (regex.test(value)) {
                setSubscriptionData({
                    ...subscriptionData,
                    [name]: value,
                });
            }
        } else if (name === 'trialAmount') {
            // Regex to match the input value with up to 2 decimal places
            const regex = /^(0|[1-9][0-9]{0,2})?$/
            if (regex.test(value)) {
                const freeChecked = (value == "0") ? true : false
                setSubscriptionData({
                    ...subscriptionData,
                    [name]: value,
                    ['isFree']: freeChecked,
                });
            }
        } else if (name === 'washnumber') {

            // validate max number of washes per day does not exceed number of washes

            const numberofwashes = parseInt(value);
          //  const washperDay = subscriptionData && subscriptionData.maxwashperday && parseInt(subscriptionData.maxwashperday);
            const washperDay = parseInt(value);
            if (washperDay && washperDay > numberofwashes) {
                setErrors((prev) => ({
                    ...prev,
                    maxwashperday: CommonMessages.wash_per_day_exceed,
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    maxwashperday: '',
                }));
            }

            const regex = /^(0|[1-9][0-9]{0,2})?$/

            if (regex.test(value)) {
                setSubscriptionData({
                    ...subscriptionData,
                    [name]: value,
                });
            }
        } else if (name === 'maxwashperday') {

            // validate max number of washes per day does not exceed number of washes

            const numberofwashes = subscriptionData.washnumber && parseInt(subscriptionData.washnumber);
            const washperDay = parseInt(value);


            if (numberofwashes && washperDay > numberofwashes) {
                setErrors((prev) => ({
                    ...prev,
                    maxwashperday: CommonMessages.wash_per_day_exceed,
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    maxwashperday: '',
                }));
            }

            const regex = /^(0|[1-9][0-9]{0,2})?$/

            if (regex.test(value)) {
                setSubscriptionData({
                    ...subscriptionData,
                    [name]: value,
                });
            }
        } else {
            setSubscriptionData({
                ...subscriptionData,
                [name]: value,
            });
        }
    }

    const validateFamilyPlan = (): boolean => {
    const newErrors: any = {};
        if(discountData)
        {
            Object.entries(discountData).forEach(([key, value]) => {
            if (!value) {
                newErrors[key as keyof DiscountData] = "This field is required";
            }else if (isNaN(Number(value)))  {
                newErrors[key as keyof DiscountData] = "Please enter a valid number";
            }
        
            });
        }
    
    setFamilyPlanErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


    // Triggers on submit
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        try {
            if (subscriptionData.subscription === "day") {

                // In case of single type subscription washnumber is defaulted to 1
                subscriptionData.washnumber = "1"
            }
            if (showCategory && !category) {
                setErrors({
                    ...errors,
                    category: "Select Category."
                });
                return false;
            }
               subscriptionData.userFamilyDiscount = discountData
               console.log(discountData)
            // Validate form data
            const isFamilyplanEmpty = discountData ?  Object.values(discountData).every(
                (value) => value === "" || value === null
                ) : true;
                if(isFamilyPlan &&   !validateFamilyPlan()) 
                {
                    return
                }

            // Validate form data
            await addSubscriptionSchema.validate(subscriptionData, { abortEarly: false });

            if (subscriptionData.isTrial === true && (subscriptionData.trialPeriod == "" || subscriptionData.trialPeriod == "0")) {
                setErrors({
                    ...errors,
                    ["trialPeriod"]: "Select trial period duration."
                });
                return false;
            }
            if (subscriptionData.isTrial === true && subscriptionData.isFree === false && subscriptionData.trialAmount == "") {
                setErrors({
                    ...errors,
                    ["trialAmount"]: "Enter trial amount."
                });
                return false;
            }

            if (subscriptionData.isTrial === true && subscriptionData.isFree === false && Number(subscriptionData.trialAmount) > Number(subscriptionData.amount)) {
                setErrors({
                    ...errors,
                    ["trialAmount"]: "The trial period amount should be less than the subscription amount."
                });
                return false;
            }
            const locationIdArray = subscriptionData.location && subscriptionData.location.map(loc => loc.value)
            console.log("isFamilyplanEmpty",isFamilyplanEmpty)
            const newData = 
            // (fullEditAllowed === false) ? {
            //     subscriptionId: param.id ? parseInt(param.id) : 0,
            //     washName: subscriptionData.washname,
            //     subscriptionDetails: subscriptionData.washdetails,
            //     isTrial: (subscriptionData.isTrial) ? 1 : 0,
            //     trialPeriod: (subscriptionData.isTrial && subscriptionData.trialPeriod) ? Number(subscriptionData.trialPeriod) : 0,
            //     trialAmount: (subscriptionData.trialAmount && subscriptionData.isTrial) ? parseFloat(subscriptionData.trialAmount) : 0,
            //     price: Number(subscriptionData.amount),
            //     dailyWashLimit: (subscriptionData.maxwashperday ) ? Number(subscriptionData.maxwashperday) : 1,
            //     numberOfWashes:subscriptionData.washnumber,
            // } : 
            {
                locationIds: locationIdArray,
                subscriptionId: param.id ? parseInt(param.id) : 0,
                washName: subscriptionData.washname,
                subscriptionDetails: subscriptionData.washdetails,
                isTrial: (subscriptionData.isTrial) ? 1 : 0,
                trialPeriod: (subscriptionData.isTrial && subscriptionData.trialPeriod) ? Number(subscriptionData.trialPeriod) : 0,
                trialAmount: (subscriptionData.trialAmount && subscriptionData.isTrial) ? parseFloat(subscriptionData.trialAmount) : 0,
                price: Number(subscriptionData.amount),
                dailyWashLimit: (subscriptionData.maxwashperday ) ? Number(subscriptionData.maxwashperday) : 1,
                numberOfWashes: subscriptionData.washnumber,
                hasVacuumWash: subscriptionData?.hasVacuumWash ,
                numberOfVacuumWashes:Number(subscriptionData?.numberOfVacuumWashes ?? 0),
                maxVacuumTime: Number(subscriptionData?.maxVacuumTime ?? 0),
                userFamilyDiscount : isFamilyplanEmpty ? null : discountData,
                // discountData && !isFamilyplanEmpty ? discountData : null,
                isUnlimitedWash:subscriptionData.isUnlimitedWash ? true :false,
                isPriceHoldEnabled: subscriptionData.isPriceHoldEnabled ? true : false,
                isPriceHoldEmail: subscriptionData.isPriceHoldEnabled && subscriptionData.isPriceHoldEmail ? true : false,
                hasSelfService:subscriptionData.hasSelfService,
                numberOfSelfServices:Number(subscriptionData.numberOfSelfServices ?? 0),
                maxSelfServiceTime:Number(subscriptionData.maxSelfServiceTime ?? 0),
                washCategoryId: showCategory ? Number(category) : null,
            }
            console.log("newData",newData)


            try {
                setLoading(true)
                const { data } = (!carwash_owner) ?
                    await axios.post(SubscriptionApi.SUBSCRIPTION_EDIT, newData)
                    : await axios.post(SubscriptionApi.CARWASH_OWNER_SUBSCRIPTION_EDIT, newData)
                    setLoading(false)
                if (data?.error === 0) {
                    if (!carwash_owner) {
                        const redirectUrl = (fullEditAllowed === true && data?.data?.is_same_locations === false) ? `/superadmin/${pageURLs.add_relaynumber}/${param.carWashId}/${newData.subscriptionId}` : `/superadmin/${pageURLs.manage_subscriptions}/${param.carWashId}`
                        navigate(redirectUrl)
                    } else {
                        const redirectUrl = (fullEditAllowed === true && data?.data?.is_same_locations === false) ? `/${pageURLs.add_relaynumber}/${newData.subscriptionId}` : `/${pageURLs.manage_subscriptions}?bayType=${currentBayType}`
                        navigate(redirectUrl)
                    }
                }
                else {
                    // show error message
                    toaster.toastError(data?.message);
                }
            } catch (error: any) {
                throw new Error(error?.response?.data?.message || error?.message);
            }
            finally {
                setLoading(false); // Hide loader
            }


        } catch (error) {
            const newErrors: any = {};

            // If validation fails on submit, then errors are shown
            if (error instanceof Yup.ValidationError) {
                error.inner.forEach((err) => {
                    newErrors[err.path as keyof typeof subscriptionData] = err.message;
                });
                setErrors(newErrors);
            }

            // Focus on the first invalid field
            if (formRef.current) {
                const firstInvalidField = Object.keys(newErrors)[0];
                const invalidElement = formRef.current.querySelector<HTMLInputElement>(`[name="${firstInvalidField}"]`);
                if (invalidElement) {
                    invalidElement.focus();
                }
            }
        }
    }

    // Navigate accordung to url
    const itemClick = async (url: string) => {
        navigate(url);
    }

    // Use useEffect to focus on the first editable field when the form loads
    // useEffect(() => {
    //     if (formRef.current) {

    //         console.log(formRef.current)
    //         // Find the first editable field
    //         const firstEditableElement = formRef.current.querySelector<HTMLInputElement | HTMLSelectElement | HTMLDivElement>(
    //             'input, select, textarea'
    //         );
    //         if (firstEditableElement) {
    //             firstEditableElement.focus();
    //         }
    //     }
    // }, []);


    const options = [
        { label: 'Select', value: '0' },
        { label: 'One Month', value: '1' },
        { label: 'Two Months', value: '2' },
        { label: 'Three Months', value: '3' },
        { label: 'Four Months', value: '4' },
        { label: 'Five Months', value: '5' },
        { label: 'Six Months', value: '6' },
        { label: 'Seven Months', value: '7' },
        { label: 'Eight Months', value: '8' },
        { label: 'Nine Months', value: '9' },
        { label: 'Ten Months', value: '10' },
        { label: 'Eleven Months', value: '11' },
        { label: 'Twelve Months', value: '12' },
    ];
const setUnLimitedData = async (e: any) => {
    if (e.target.checked === true) {
         setSubscriptionData({
            ...subscriptionData,
            [e.target.name]: e.target.checked,
            ['washnumber']:'0'
        });
     }
     else{
         setSubscriptionData({
            ...subscriptionData,
            [e.target.name]: e.target.checked,
        });
     }
}
    const setTrailPeriodData = async (e: any) => {
        if (e.target.name === 'isTrial') {
            if (e.target.checked === true) {
                setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                });
            } else {
                setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                    ['trialPeriod']: '0',
                    ['isFree']: false,
                    ['trialAmount']: '',
                });
            }
        } else if (e.target.name === 'isFree') {
            setErrors({
                ...errors,
                ["trialAmount"]: ""
            })
            if (e.target.checked === true) {
                setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                    ['trialAmount']: '0',
                });
            } else {
                setSubscriptionData({
                    ...subscriptionData,
                    [e.target.name]: e.target.checked,
                    ['trialAmount']: '0',
                });
            }
        }
    }

    return (

        <div className='manage-carwash-container manage-subscription-container'>
            <Container>
                <Breadcrumb>
                    {props.userType !== userType["CARWASH-OWNER"] ?
                        <>
                            <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.manage_carwash}`) }}>Manage Car Washes</Breadcrumb.Item>
                            {companyDetails && (<Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.carwash_locations}/${param.carWashId}`) }}  > {companyDetails.CompanyName}</Breadcrumb.Item>)}
                        </>
                        : null}

                    <Breadcrumb.Item onClick={() =>
                        itemClick(
                            props.userType !== userType["CARWASH-OWNER"]
                                ? `/superadmin/${pageURLs.manage_subscriptions}/${param.carWashId}`
                                : `/${pageURLs.manage_subscriptions}?type=${subscription_type}`
                        )
                    }>
                        Manage Subscriptions
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>{subscription_type === 'day' ? 'Edit Single Wash' : 'Edit Subscription'}</Breadcrumb.Item>
                </Breadcrumb>
                {props.userType !== userType["CARWASH-OWNER"] ?

                    <div className="manage-activity-wrap d-flex justify-content-between align-items-center">
                        {companyDetails && <GenerateLink id={param.id} companyDetails={companyDetails} carwash_owner={carwash_owner} />}
                        <div className="activity-status d-flex">
                            <CarWashStatus carWashId={param.id} status={(companyDetails?.IsCompanyActive == 1) ? true : false} companyName={companyDetails.CompanyName} />
                            <div className="stat-group d-flex align-items-center">
                                <p>Subscription Status</p>
                                <Badge className='active'>Active</Badge>
                            </div>

                        </div>
                    </div> : null}
                <div className='cw-form-outer-wrap'>
                    <form onSubmit={(e) => handleSubmit(e)} ref={formRef}>
                        <div className="cw-form-container">
                            <div className="form-inner mx-auto">
                                {/* <CWSelect
                                    id="location"
                                    name="location"
                                    options={locations}
                                    label="Select Location"
                                    dropdownGap={0}
                                    dropdownPosition="auto"
                                    isMandatory
                                    placeholder="Select Location"
                                    multi={true}
                                    errorMessage={errors.location}
                                    onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'location')}
                                /> */}
                                <div>
                                    <CWMultiSelect
                                        id="location"
                                        name="location"
                                        options={locations}
                                        label="Select Location"
                                        dropdownGap={0}
                                        dropdownPosition="auto"
                                        isMandatory
                                        placeholder="Select Location"
                                        errorMessage={errors.location}
                                        onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, "location")}
                                        hasSelectAll={true}
                                        value={subscriptionData.location || selectedLocation}//Correction required
                                        labelAllSelected="All Locations Selected."
                                        // disabled ={fullEditAllowed === true ? false : true}
                                        disabled={true}
                                        />
                                </div>
                                <CWSelect
                                    id="subscription"
                                    name="subscription"
                                    options={subscriptionTypes}
                                    label="Select Subscription Type"
                                    isMandatory
                                    dropdownGap={0}
                                    dropdownPosition="auto"
                                    placeholder="Select Subscription Type"
                                    multi={false}
                                    values={subscriptionTypes.filter(option => option.value === subscriptionData.subscription)}
                                    errorMessage={errors.subscription}
                                    onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'subscription')}
                                    disabled 
                                />
                                {showCategory && <Row>
                                    <Col md={12}>
                                        <CWSelect
                                            id="category"
                                            name="category"
                                            options={categoryOptions}
                                            label="Category"
                                            isMandatory
                                            dropdownGap={0}
                                            dropdownPosition="auto"
                                            placeholder="Select Category"
                                            multi={false}
                                            searchable={false}
                                            errorMessage={errors.category}
                                            values={categoryOptions.filter(option => option.value === category)}
                                            onChange={(selectedOptions) => handleCategoryChange(selectedOptions[0])}
                                        />
                                    </Col>
                                </Row>}
                                <Row>
                                    <Col md={6}>
                                        <CWInput
                                            id="washname"
                                            name="washname"
                                            type="text"
                                            label="Wash Name"
                                            maxLength={WASH_NAME_MAX_LENGTH}
                                            isMandatory
                                            value={subscriptionData.washname}
                                            errorMessage={errors.washname}
                                            onChange={handleInputChange}
                                        />
                                    </Col>
                                    <Col md={6}>
                                    <div  key={editorKey} className='mb-4'>
                                        <div className="form-group cw-input">
                                    <div className="cust-label-group">
                                        <label htmlFor="label">Wash details
                                            <span className="mandatory">*</span>
                                        </label>
                                              <CKEditor
                                            editor={ClassicEditor as any}
                                            config={{
                                                licenseKey: 'GPL',
                                                plugins: [Essentials, Paragraph, Bold, Italic, Heading],
                                                toolbar: [
                                                    'heading', '|', 'bold', 'italic', 'underline', 'strikethrough', '|',
                                                    'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
                                                    'undo', 'redo', '|', 'alignment', 'fontSize', 'fontColor',
                                                    'fontBackgroundColor', 'highlight', 'codeBlock',
                                                    'insertTable', 'imageUpload', 'mediaEmbed'
                                                ],
                                                heading: {
                                                    options: [
                                                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
                                                    ]
                                                },
                                                image: {
                                                    toolbar: [
                                                        'imageTextAlternative', 'toggleImageCaption',
                                                        'imageStyle:full', 'imageStyle:side'
                                                    ]
                                                },
                                                table: {
                                                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
                                                },
                                                
                                            }}
                                            
                                            onReady={(editor) => {
                                                if (subscriptionData.washdetails) {
                                                    editor.setData(subscriptionData.washdetails);
                                                }
    
                                            }}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                setSubscriptionData((prev) => ({
                                                    ...prev,
                                                    washdetails: data,
                                                }));
                                                setErrors({
                                                        ...errors,
                                                        ['washdetails']: ""
                                                    })
    
                                            }}
                                                                                                            
                                    />
                                    <span className='error-msg'>{errors.washdetails}</span>

                                    </div>
                                    </div>
                                    </div>
                                        {/* <CWTextarea
                                            id="washdetails"
                                            name="washdetails"
                                            type="text"
                                            label="Wash Details"
                                            maxLength={WASH_DETAIL_MAX_LENGTH}
                                            isMandatory
                                            value={subscriptionData.washdetails}
                                            errorMessage={errors.washdetails}
                                            onChange={handleInputChange}
                                        /> */}
                                    </Col>
                                </Row>
                                <Row>
                                    {!subscriptionData.isUnlimitedWash? <Col md={6}>
                                        <div className="custom-note position-relative">
                                            <CWInput
                                                id="washnumber"
                                                name="washnumber"
                                                type="number"
                                                label="Number of Washes"
                                                maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={subscriptionData.subscription === "day" ? 1 : subscriptionData.washnumber}
                                                errorMessage={errors.washnumber}
                                                onChange={handleInputChange}
                                                // readOnly ={fullEditAllowed === true ? false : true}
                                                

                                            />
                                            <span className="note"><i>*Single Wash value will be set to 1 by default</i></span>
                                        </div>
                                    </Col>:""}

                                    {subscriptionData.subscription === "month" ?

                                    <>
                                    <Col md={3}>
                                    <CWCheckbox
                                        id="isUnlimitedWash"
                                        name="isUnlimitedWash"
                                        label="Unlimited Wash"
                                        checked={subscriptionData.isUnlimitedWash}
                                        onChange={(e) => { setUnLimitedData(e); }}
                                    />
                                    </Col>
                                    <Col md={3}>
                                    <CWCheckbox
                                        id="isPriceHoldEnabled"
                                        name="isPriceHoldEnabled"
                                        label="60-Day Price Hold After Update"
                                        checked={subscriptionData.isPriceHoldEnabled}
                                        onChange={(e) => {
                                            setSubscriptionData({
                                                ...subscriptionData,
                                                [e.target.name]: e.target.checked,
                                                isPriceHoldEmail: e.target.checked ? subscriptionData.isPriceHoldEmail : false,
                                            });
                                        }}
                                    />
                                    {subscriptionData.isPriceHoldEnabled ? (
                                    <CWCheckbox
                                        id="isPriceHoldEmail"
                                        name="isPriceHoldEmail"
                                        label="Notify customers by email about subscription price updates"
                                        helptext="Checked: Send an email notification to customers. Unchecked: No email notification will be sent."
                                        checked={subscriptionData.isPriceHoldEmail}
                                        onChange={(e) => {
                                            setSubscriptionData({
                                                ...subscriptionData,
                                                [e.target.name]: e.target.checked,
                                            });
                                        }}
                                    />
                                    ) : null}
                                    </Col>
                                        <Col md={6}>
                                            <CWInput
                                                id="maxwashperday"
                                                name="maxwashperday"
                                                type="number"
                                                label="Maximum Number of Washes per day"
                                                maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={subscriptionData.maxwashperday}
                                                errorMessage={errors.maxwashperday}
                                                onChange={handleInputChange}
                                            />
                                        </Col></> : null}
                                    <Col md={6}>
                                        <CWInputGroup
                                            id="amount"
                                            name="amount"
                                            type="number"
                                            step='0.01'
                                            label="Amount"
                                            labelPrefix="$"
                                            isMandatory
                                            maxLength={AMOUNT_MAX_LENGTH}
                                            value={subscriptionData.amount}
                                            errorMessage={errors.amount}
                                            onChange={handleInputChange}
                                            // readOnly={subscriptionData.subscription !== "day" && fullEditAllowed === false}
                                        />
                                    </Col>
      
                                     {subscriptionData.subscription === "month" && (
                                        <CWCheckbox
                                        id="Isfamilyplan"
                                        name="Isfamilyplan"
                                        label="Family Plan"
                                        checked={isFamilyPlan}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setIsFamilyPlan(checked);
                                            if (!checked) {
                                            setDiscountData(null);
                                            setFamilyPlanErrors({});
                                            }
                                        }}
                                        />
                                    )}

                                    {isFamilyPlan && (
                                        <Row>
                                        {[...Array(10)].map((_, index) => {
                                            const key = `discount${index + 1}`;
                                            return (
                                            <Col md={4} key={key}>
                                                <CWInputGroup
                                                id={key}
                                                name={key}
                                                type="number"
                                                step='0.01'
                                                label={`Amount to be paid for Family Plan (Sub User ${index + 1}${index === 0 ? ', not account owner' : ''})`}
                                                labelPrefix="$"
                                                maxLength={AMOUNT_MAX_LENGTH}
                                                value={discountData && discountData[key] || ""}
                                                errorMessage={familyPlanErrors[key]}
                                                onChange={handleDiscountChange}
                                                />
                                            </Col>
                                            );
                                        })}
                                        </Row>
                                    )}
                                </Row>
                                {subscriptionData.subscription === 'month' ? <div className="trial-sec mt-4">
                                    <CWCheckbox
                                        id="isTrial"
                                        name="isTrial"
                                        label="Offer Trial Period"
                                        checked={subscriptionData.isTrial}
                                        onChange={(e) => { setTrailPeriodData(e); }}
                                    />
                                    {subscriptionData.isTrial ? <Row>
                                        <Col md={6}>
                                            <CWSelect
                                                id="duration"
                                                name="trialPeriod"
                                                options={options}
                                                label="Duration"
                                                dropdownGap={0}
                                                dropdownPosition="auto"
                                                placeholder="Select"
                                                multi={false}
                                                isMandatory
                                                className="no-input"
                                                errorMessage={errors.trialPeriod}
                                                values={options.filter(option => option.value === subscriptionData.trialPeriod)}
                                                onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'trialPeriod')}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <div className="trial-period">
                                                <p>Amount in trial period</p>
                                                <div className="d-flex align-items-center field-group">
                                                    <CWCheckbox
                                                        id="free"
                                                        name="isFree"
                                                        label="Free"
                                                        checked={subscriptionData.isFree}
                                                        onChange={(e) => { setTrailPeriodData(e); }}

                                                    />
                                                    <CWInputGroup
                                                        id="traialamount"
                                                        name="trialAmount"
                                                        type="text"
                                                        labelPrefix="$"
                                                        maxLength={AMOUNT_MAX_LENGTH}
                                                        value={subscriptionData.trialAmount}
                                                        errorMessage={errors.trialAmount}
                                                        onChange={handleInputChange}
                                                        readOnly={isTrailAmountNonEditable}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row> : ''}
                                </div> : ''}
                                {/* free vacuum wash */}
 <div className="trial-sec mt-4">
                                    <CWCheckbox
                                        id="hasVacuumWash"
                                        name="hasVacuumWash"
                                        label="Offer Free Vacuum / Mat Washer"
                                        checked={subscriptionData.hasVacuumWash}
                                        onChange={(e) => { setFreeVacuumData(e); }}
                                    />
                                    {subscriptionData.hasVacuumWash ? <Row>
                                      {subscriptionData.subscription === 'month'  ?  <Col md={6}>
                                            <CWInput
                                                id="numberOfVacuumWashes"
                                                name="numberOfVacuumWashes"
                                                label="Number of Times per Month"
                                                 maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={subscriptionData.numberOfVacuumWashes}
                                                errorMessage={errors.numberOfVacuumWashes}
                                                onChange={handleInputChange}
                                            />
                                        </Col>:""}
                                        <Col md={6}>
                                                <CWInput
                                                id="maxVacuumTime"
                                                name="maxVacuumTime"
                                                label="Maximum Time per Use (in minutes)"
                                                 maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={subscriptionData.maxVacuumTime}
                                                errorMessage={errors.maxVacuumTime}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row> : ''}
                                </div>
                                 {subscriptionData.subscription === "month" ?
                                <div className="trial-sec mt-4">
                                    <CWCheckbox
                                        id="hasSelfService"
                                        name="hasSelfService"
                                        label="Offer Self Serve"
                                        checked={subscriptionData.hasSelfService}
                                        onChange={(e) => { setFreeSelfServeData(e); }}
                                    />
                                    {subscriptionData.hasSelfService ? <Row>
                                       <Col md={6}>
                                            <CWInput
                                                id="numberOfSelfServices"
                                                name="numberOfSelfServices"
                                                label="Number of Times per Month"
                                                 maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={subscriptionData.numberOfSelfServices}
                                                errorMessage={errors.numberOfSelfServeWashes}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col md={6}>
                                                <CWInput
                                                id="maxSelfServiceTime"
                                                name="maxSelfServiceTime"
                                                label="Maximum Time per Use (in minutes)"
                                                 maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={subscriptionData.maxSelfServiceTime}
                                                errorMessage={errors.maxSelfServiceTime}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row> : ''}
                                </div> :""}
                            </div>
                        </div>
                        <div className="btn-sec d-flex justify-content-end">
                            <Button title="Cancel" variant="primary" className="secondary-btn" onClick={() => props.userType !== userType["CARWASH-OWNER"] ? navigate(`/superadmin/${pageURLs.manage_subscriptions}/${param.carWashId}`) : navigate(`/${pageURLs.manage_subscriptions}`)}>Cancel</Button>
                            <Button title="Save" variant="primary" className="primary-btn" type="submit">Save</Button>
                        </div>
                    </form>
                </div>
            </Container>

            {loading && <SmallLoader />}

        </div >
    )
}

export default EditSubscription;
